module.exports = __webpack_public_path__ + "static/media/icon-who-we-are-2.e915cfea.svg";